<template>
  <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TabbedPortletContainer',
  inheritAttrs: false
}
</script>
